/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// utils
import transpileEmbedSettings from 'utils/transpilers/embedsettings';
import transpileContentData from 'utils/transpilers/contentdata';
import { pqContentData } from 'data/profilingquestions';
import { url } from 'utils/urls';
import { environment } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embediframe/embediframe_styles';



/* ========== ~~~~~~~~~~ EMBED IFRAME ~~~~~~~~~~ ========== */
class EmbedIFrame extends Component {
    constructor(props) {
        super(props);
        this.iframeEl = null;
    }
    componentDidMount() {
        // set iframe styles
        this.iframeEl.frameBorder = "0";
        this.iframeEl.scrolling = "no";
        this.iframeEl.marginheight = "0";
        this.iframeEl.marginwidth = "0";
        this.iframeEl.topmargin = "0";
        this.iframeEl.leftmargin = "0";
        this.iframeEl.allowtransparency = "true";
        const contentData = transpileContentData(this.props.contentStatus, this.props.selectedEmbedStatus.selectedEmbedData);

        // append objects and functions to iframe window (embed application will read from and utilize these to build itself)
        this.iframeEl.contentWindow.embedSettings = transpileEmbedSettings(this.props.selectedEmbedStatus.selectedEmbedData, this.props.contentStatus, this.props.addOn);
        this.iframeEl.contentWindow.getEmbedSettings = function() { return this.embedSettings };

        this.iframeEl.contentWindow.mxQuestionData = contentData.mxQuestionData;
        this.iframeEl.contentWindow.getMxQuestionData = function() { return JSON.parse(this.mxQuestionData) };

        this.iframeEl.contentWindow.mxResultData = contentData.mxResultData;
        this.iframeEl.contentWindow.getMxResultData = function() { return JSON.parse(this.mxResultData) };

        this.iframeEl.contentWindow.pqQuestionData = pqContentData;
        this.iframeEl.contentWindow.getPqQuestionData = function() { return this.pqQuestionData };

        this.iframeEl.contentWindow.udcData = contentData.udcData;
        this.iframeEl.contentWindow.getUDCData = function() { return JSON.parse(this.udcData) };
        // create div inside iframe
        const div = document.createElement("div");
        div.id = "app";
        // create script inside iframe head that will load embed application into div
        var script = document.createElement("script");
        script.type = "text/javascript";
        // PROD Hotfix for outdated embed distribution, logo and broken link
        // script.src = environment === 'PRODUCTION' ? 'https://product.instiengage.com/ceu-core-script/embed_core.js' : url.embedv4;
        script.src = url.embedv4; 
        // We have to timeout appending embed script and div to the head and the body of the iframe to solve a known Firefox specific issue.
        // More info: https://stackoverflow.com/questions/3255702/firefox-strange-behaviour-when-working-with-javascript-on-an-iframe
        window.setTimeout(() => {
            this.iframeEl.contentWindow.document.body.appendChild(div);
            this.iframeEl.contentWindow.document.head.appendChild(script);

            // PROD Hotfix for broken logo link
            const logoLinkFixScript = document.createElement('script')
            logoLinkFixScript.textContent = `
              const fixBrokenLogoLink = () => {
                const logosLinkEl = document.getElementsByClassName('logo insticator');
                for(var i = 0; i < logosLinkEl.length; i++) {
                  const companyLink = logosLinkEl[i].href.replace('instiengage.com', 'insticator.com')
                  logosLinkEl[i].href = companyLink;      
                }
              }
              // To fix broken link on the out of content screen
              document.addEventListener('mouseover', fixBrokenLogoLink);
            `
            logoLinkFixScript.type = 'text/javascript'
            this.iframeEl.contentWindow.document.head.appendChild(logoLinkFixScript);
        },100);
        
    };
    render() {
        const embedLocation = this.props.location;
        return (
            <div className={`embediframe ${this.props.classes.embediframe}`}>
                <div id="insticator-container">
                    <div id="div-insticator-ad-1" className={`${embedLocation === 'rail' ? 'rail' : null}`}>
                        <div className={`desc`}>Ad 1</div>
                    </div>
                    <div id="insticator-embed" className={embedLocation === 'rail' ? 'rail' : null} >
                        <iframe id="insticator-iframe" title={`Preview Embed`} className={`embedcontainer  `} ref={input => this.iframeEl = input} />
                    </div>
                    <div id="div-insticator-ad-2" className={`${embedLocation === 'rail' ? 'rail' : null}`}>
                        <div className={`desc`}>Ad 2</div>
                    </div>
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedIFrame);
